/* eslint-disable @typescript-eslint/naming-convention */
// @ts-nocheck
import $ from 'jquery';

// Legacy. Part of the site expects data to exist on the window before bootstrapping angular.
export function API() {
    this._baseApiUrl = window.apiUrl;
    this._baseUrl = window.baseUrl;
}
window.api; // Used in the global scope.
window.API = API

export function configureGlobalWindow($window) {
    'ngInject'
    //Resolved Bug 4648:Departments being added twice, prevent multiple form submissions/ multiple clicks of submit button
    $('form').submit(function () {
        /* eslint-disable-next-line no-invalid-this */
        const form = $(this);
        if (form.valid()) {
            const submit = form.find(":submit");
            if (!submit.hasClass("neverDisable")) {
                submit.attr('disabled', 'disabled');
            }
        }
    });


    API.prototype = {
    };
    $window.api = new API();
}
